import { Component, Input } from '@angular/core';
import { TableRow } from '../../models/table-row.model';
import { SmTable2Component } from '../sm-table2/sm-table2.component';
import { FrontendFormDefinition } from '../../models/frontend-form-definition.model';
import { FrontendFieldDefinition } from '../../models/frontend-field-definition.model';

@Component({
  selector: 'app-sm-table-row-editor-form',
  templateUrl: './sm-table-row-editor-form.component.html',
  styleUrl: './sm-table-row-editor-form.component.scss'
})
export class SmTableRowEditorFormComponent {

  @Input()
  table: SmTable2Component;
  @Input()
  row: TableRow;
  @Input()
  rowIndex: number;

  form: FrontendFormDefinition;

  update(): void {
   // this.form = new FrontendFormDefinition(this.table.colDefs.map(colDef => this.columnToField(colDef)));  
  }

}